import { getObservationsRequest } from 'api/FHIR/api';
import { Observation } from 'api/FHIR/types';
import { ObservationsFilter } from 'common/types/SearchParams';
import { Pagination } from 'common/types/Pagination';

import { useState, useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import omit from 'lodash/omit';
import { camelizeKeys } from 'humps';

const useGetObservations = (userId: string) => {
  const { t } = useTranslation();

  const [ observations, setObservations ] = useState<Observation[]>([]);
  const [ pagination, setPagination ] = useState<Pagination | undefined>();
  const [ isLoading, setIsLoading ] = useState<boolean>(false);
  const [ error, setError ] = useState<string>('');

  const getObservations = useCallback((filters: ObservationsFilter, abortController: AbortController) => {
    setIsLoading(true);
    setError('');

    getObservationsRequest(userId, filters, abortController)
      .then((response) => {
        setObservations(camelizeKeys(response.data.results) as Observation[]);
        setPagination(omit(response.data, 'results'));
      })
      .catch((error) => {
        if (!abortController?.signal.aborted) {
          setError(error?.response?.data?.message || t('errors.server_error_try_again'));
        }
      })
      .finally(() => {
        if (!abortController?.signal.aborted) {
          setIsLoading(false);
        }
      });
  }, [ t, userId ]);

  return { getObservations, observations, isLoading, error, pagination };
};

export default useGetObservations;
